"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const PremiumTrialsNotFoundError_1 = __importDefault(require("./errors/PremiumTrialsNotFoundError"));
const PremiumTrialUnavailableError_1 = __importDefault(require("./errors/PremiumTrialUnavailableError"));
class TrialsServiceClient extends client_library_1.Client {
    constructor(fetch, options = {}) {
        super(fetch, options);
    }
    fetchPremiumTrials() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.url}/api/trials/me`;
            const response = yield this.requestMaker.makeRequest(url, { method: 'GET' }, [200, 404]);
            if (response.status === 404) {
                throw new PremiumTrialsNotFoundError_1.default();
            }
            return response.json;
        });
    }
    startPremiumTrial(type) {
        return __awaiter(this, void 0, void 0, function* () {
            this._validateMissingParams({ type });
            const url = `${this.url}/api/trials/start`;
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({ type })
            }, [200, 400]);
            if (response.status === 400) {
                throw new PremiumTrialUnavailableError_1.default(type);
            }
            return response.json;
        });
    }
    recordTrialEvent(type) {
        return __awaiter(this, void 0, void 0, function* () {
            this._validateMissingParams({ type });
            const url = `${this.url}/api/trials/event`;
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({ type })
            }, [200, 404]);
            if (response.status === 404) {
                throw new PremiumTrialsNotFoundError_1.default();
            }
            return response.json;
        });
    }
    fetchRecurringTrials() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.url}/api/recurring-trials/me`;
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'GET'
            }, [200]);
            return response.json;
        });
    }
}
exports.default = TrialsServiceClient;
